import { WorkItemController } from "../workItemController";
import {
  WorkItemServiceProvider,
  vsProviderName as WorkItemServiceProviderName,
} from "..";

textConfig.$inject = ["formlyConfigProvider", WorkItemServiceProviderName];
export function textConfig(
  formlyConfigProvider: AngularFormly.IFormlyConfig,
  workItemServiceProvider: WorkItemServiceProvider,
) {
  workItemServiceProvider.addWorkItemType({
    name: "Text",
    formlyFieldType: "processText",
  });

  formlyConfigProvider.setType({
    name: "processText",
    template: require("!html-loader!./index.html").default,
    controller: WorkItemController,
  });
}
